<template>
  <v-content>
    <AppBar title="Bemannings avvikelser" />
    <v-container :fluid="true">
      <v-card>
        <v-data-table
          :footer-props="footerProps"
          :loading="$apollo.loading"
          :headers="headers"
          :items="transformedStaffDeviations"
          :search="search"
          loading-text="Hämtar data..."
          no-data="Ingen data hittades..."
          no-results-text="Inget resultat på din sökning..."
          :height="tableHeight"
          :items-per-page="20"
          fixed-header
          sort-by="date"
          :sort-desc="true"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Bemannings avvikelser</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Sök..."
                single-line
                hide-details
                filled
                dense
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer />
              <v-dialog v-model="showExportModal" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn tile v-on="on" :loading="pendingExport">
                    <v-icon small left>mdi-file-export-outline</v-icon>
                    Export Excel
                  </v-btn>
                </template>
                <ExportModal
                  v-if="showExportModal"
                  @close="showExportModal = false"
                  @confirm="exportToExcel"
                />
              </v-dialog>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import tableHeight from '@/mixins/tableHeight.js'
import gql from 'graphql-tag'
import { format } from 'date-fns'
import { exportExcel } from '@/services/exportExcel.service.js'
import ExportModal from '@/components/ExportModal'
import { isWithinInterval } from 'date-fns'
import orderBy from 'lodash.orderby'
import { get } from 'vuex-pathify'

export default {
  name: 'StaffDeviationRegistrations',

  mixins: [tableHeight],

  components: {
    AppBar,
    ExportModal
  },

  data: () => ({
    showExportModal: false,
    pendingExport: false,
    footerProps: {
      itemsPerPageOptions: [10, 20, 50],
      itemsPerPageText: 'Rader per sida'
    },
    search: ''
  }),

  apollo: {
    staffDeviationRegistrations: {
      fetchPolicy: 'cache-and-network',
      query: gql`
        query {
          staffDeviationRegistrations {
            train_number
            date
            comment
            solution
            cause
            user
          }
        }
      `
    }
  },

  computed: {
    isSj: get('user/isSj'),

    transformedStaffDeviations() {
      return (this.staffDeviationRegistrations || []).map(x => ({
        ...x,
        date: format(new Date(x.date), 'yyyy-MM-dd')
      }))
    },

    headers() {
      return [
        {
          text: 'Datum.',
          value: 'date',
          width: 150
        },
        {
          text: 'Tågnr.',
          value: 'train_number'
        },
        {
          text: 'Orsak',
          value: 'cause',
          width: 250
        },
        {
          text: 'Förstärkningsbehov',
          value: 'solution'
        },
        {
          text: 'Kommentar.',
          value: 'comment'
        },
        {
          text: 'Skapad av',
          value: 'user'
        }
      ].filter(header => (!this.isSj ? header.value !== 'user' : true))
    }
  },

  methods: {
    async exportToExcel(period) {
      const filteredStaffDeviations = orderBy(
        this.transformedStaffDeviations,
        ['date'],
        ['desc']
      ).filter(x => {
        return isWithinInterval(new Date(x.date), {
          start: new Date(period.from),
          end: new Date(period.to)
        })
      })
      this.pendingExport = true
      const filename = `Export - Bemannings avvikelser`
      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'Bemannings avvikelser',
            data: filteredStaffDeviations.map(row => {
              return this.headers.reduce((acc, col) => {
                acc[col.text] = row[col.value]
                return acc
              }, {})
            })
          }
        ]
      }

      await exportExcel(this.$apollo.provider.defaultClient, filename, workbook)

      this.pendingExport = false
    }
  }
}
</script>
